<template>
    <div class="area-picker">
        <el-select 
            v-model="provinceValue" 
            placeholder="请选择省份" 
            :disabled="disabled"
            filterable
            @change="onProvinceChange">
            <el-option 
                v-for="item in provinces" 
                :key="item.value" 
                :label="item.label" 
                :value="item.value">
            </el-option>
        </el-select>
        <el-select 
            v-model="cityValue" 
            placeholder="请选择城市" 
            :disabled="disabled || !provinceValue"
            filterable
            @change="onCityChange">
            <el-option 
                v-for="item in cities" 
                :key="item.value" 
                :label="item.label" 
                :value="item.value">
            </el-option>
        </el-select>
        <el-select 
            v-model="districtValue" 
            placeholder="请选择区县" 
            :disabled="disabled || !cityValue"
            filterable
            @change="onDistrictChange">
            <el-option 
                v-for="item in districts" 
                :key="item.value" 
                :label="item.label" 
                :value="item.value">
            </el-option>
        </el-select>
    </div>
</template>

<script>
import area from "@/assets/json/area.json";

export default {
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        value: {
            type: Array,
            default: () => []
        }
    },

    model: {
        event: 'change'
    },

    data() {
        return {
            area,
            provinces: [],
            cities: [],
            districts: [],
            provinceValue: null,
            cityValue: null,
            districtValue: null
        }
    },

    created() {
        this.provinces = this.area.map(province => ({
            label: province.label,
            value: province.value
        }));
        
        // 初始化值
        this.initValue();
    },

    methods: {
        // 初始化值
        initValue() {
            if (this.value && this.value.length > 0) {
                this.provinceValue = this.value[0];
                this.loadCities();
                
                if (this.value.length > 1) {
                    this.cityValue = this.value[1];
                    this.loadDistricts();
                    
                    if (this.value.length > 2) {
                        this.districtValue = this.value[2];
                    }
                }
            }
        },
        
        // 省份改变
        onProvinceChange() {
            this.cityValue = null;
            this.districtValue = null;
            this.districts = [];
            
            this.loadCities();
            this.emitChange();
        },
        
        // 城市改变
        onCityChange() {
            this.districtValue = null;
            
            this.loadDistricts();
            this.emitChange();
        },
        
        // 区县改变
        onDistrictChange() {
            this.emitChange();
        },
        
        // 加载城市数据
        loadCities() {
            if (this.provinceValue) {
                const province = this.area.find(p => p.value === this.provinceValue);
                if (province && province.children) {
                    this.cities = province.children.map(city => ({
                        label: city.label,
                        value: city.value
                    }));
                } else {
                    this.cities = [];
                }
            } else {
                this.cities = [];
            }
        },
        
        // 加载区县数据
        loadDistricts() {
            if (this.provinceValue && this.cityValue) {
                const province = this.area.find(p => p.value === this.provinceValue);
                if (province && province.children) {
                    const city = province.children.find(c => c.value === this.cityValue);
                    if (city && city.children) {
                        this.districts = city.children.map(district => ({
                            label: district.label,
                            value: district.value
                        }));
                    } else {
                        this.districts = [];
                    }
                } else {
                    this.districts = [];
                }
            } else {
                this.districts = [];
            }
        },
        
        // 发送改变事件
        emitChange() {
            const value = [];
            if (this.provinceValue) {
                value.push(this.provinceValue);
                if (this.cityValue) {
                    value.push(this.cityValue);
                    if (this.districtValue) {
                        value.push(this.districtValue);
                    }
                }
            }
            console.log(value);
            
            this.$emit("change", value);
        }
    },
    
    watch: {
        value(newVal) {
            // 当外部value改变时，重新初始化
            this.initValue();
        }
    }
}
</script>

<style scoped lang="scss">
.area-picker {
    width: 100%;
    display: flex;
    gap: 10px;
    
    ::v-deep(.el-select) {
        width: 120px;
    }
}
</style>
